import PanelSearch from './PanelSearch';
export default PanelSearch;